import AppHeader from '../AppHeader'

export default {
  name: 'message-sent',
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-sent.js